<template>
    <div class="tooth-wrap-rpd">
        <!-- <div class="reset-button-wrap">
            <el-button type="primary" size="mini" plain @click="resetAllTeeth">重置牙位</el-button>
            <el-button type="primary" size="mini" plain @click="undo">撤销</el-button>
        </div> -->
        <div class="tooth-wrap-label-rpd">
            <i class="el-icon-s-help" style="color: #23D96E;"></i>&nbsp;&nbsp;钢牙
            <br>
            <i class="el-icon-s-help" style="color: #ff4757;"></i>&nbsp;&nbsp;充胶牙
            <br>
        </div>
        <!-- 上颌 -->
        <div class="tooth-model">
            <!-- 上颌左侧 -->
            <div class="tooth-model-item" style="margin-top: 45px;">
                <div v-for="tooth in teeth.slice(0, 7)" :key="tooth.id" @click="toggleSelection(tooth)">
                    <img :id="'tooth-' + tooth.id"
                        :src="'/static/images/tooth/teeth/' + tooth.id + (tooth.active ? '' : '_active') + '.png'" />
                    <span :class="'tooth-' + tooth.id">
                        <i v-if="steelTeethList.includes(tooth.id)" class="el-icon-s-help" style="color: #23D96E;"></i>
                        <i v-else-if="glueTeethList.includes(tooth.id)" class="el-icon-s-help"style="color: #ff4757;"></i>
                        <p v-else class="tooth-label" :style="tooth.active ? 'color:#CCCCCC;' : 'color:black;'">{{ tooth.id }}</p>
                    </span>
                </div>
            </div>
            <!-- 上颌右侧 -->
            <div class="tooth-model-item" style="margin-top: 45px;">
                <div v-for="tooth in teeth.slice(7, 14)" :key="tooth.id" @click="toggleSelection(tooth)">
                    <img :id="'tooth-' + tooth.id"
                        :src="'/static/images/tooth/teeth/' + tooth.id + (tooth.active ? '' : '_active') + '.png'" />
                    <span :class="'tooth-' + tooth.id">
                        <span :class="'tooth-' + tooth.id">
                            <i v-if="steelTeethList.includes(tooth.id)" class="el-icon-s-help" style="color: #23D96E;"></i>
                            <i v-else-if="glueTeethList.includes(tooth.id)" class="el-icon-s-help"style="color: #ff4757;"></i>
                            <p v-else class="tooth-label" :style="tooth.active ? 'color:#CCCCCC;' : 'color:black;'">{{ tooth.id }}</p>
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <!-- 下颌 -->
        <div class="tooth-model" style="margin: 20px 0 0 5px;">
            <!-- 下颌左侧 -->
            <div class="tooth-model-item">
                <div v-for="tooth in teeth.slice(22, 32)" :key="tooth.id" @click="toggleSelection(tooth)">
                    <img :id="'tooth-' + tooth.id"
                        :src="'/static/images/tooth/teeth/' + tooth.id + (tooth.active ? '' : '_active') + '.png'" />
                    <span :class="'tooth-' + tooth.id">
                        <span :class="'tooth-' + tooth.id">
                            <i v-if="steelTeethList.includes(tooth.id)" class="el-icon-s-help" style="color: #23D96E;"></i>
                            <i v-else-if="glueTeethList.includes(tooth.id)" class="el-icon-s-help"style="color: #ff4757;"></i>
                            <p v-else class="tooth-label" :style="tooth.active ? 'color:#CCCCCC;' : 'color:black;'">{{ tooth.id }}</p>
                        </span>
                    </span>
                </div>
            </div>
            <!-- 下颌右侧 -->
            <div class="tooth-model-item">
                <div v-for="tooth in teeth.slice(15, 22)" :key="tooth.id" @click="toggleSelection(tooth)">
                    <img :id="'tooth-' + tooth.id"
                        :src="'/static/images/tooth/teeth/' + tooth.id + (tooth.active ? '' : '_active') + '.png'" />
                    <span :class="'tooth-' + tooth.id" :style="tooth.active ? 'color:#CCCCCC;' : 'color:black;'">
                        <span :class="'tooth-' + tooth.id">
                            <i v-if="steelTeethList.includes(tooth.id)" class="el-icon-s-help" style="color: #23D96E;"></i>
                            <i v-else-if="glueTeethList.includes(tooth.id)" class="el-icon-s-help"style="color: #ff4757;"></i>
                            <p v-else class="tooth-label" :style="tooth.active ? 'color:#CCCCCC;' : 'color:black;'">{{ tooth.id }}</p>
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        /**
         * 逻辑：
         * 1.adjunct判断牙位材质
         * 2.initTooth初始化所有牙位
         * 3.toggleSelection根据adjunct判断添加牙位材质，调用toothToggle添加牙位，removeListItem移除其他列表牙位
         * 4.isTooth判断牙位是否在选中列表中
         * 5.列表去重
         */
        return {
            // 所有牙位列表
            teeth: [],
            // 选中牙位列表
            selectedTeeth: [],
            // 钢牙列表
            steelTeethList: [],
            // 充胶牙列表
            glueTeethList: [],

            // 牙位范围字段
            shiftStartTooth:'',
            shiftEndTooth:'',
            isShiftPressed:false,
            history:[],
        };
    },
    props: {
        adjunct: {
            type: String,
            default: '00'
        },
        isDetail: {
            type: Boolean,
            default: false
        },
        teethList: {
            type: Array,
            default: ()=>[]
        },
        steelList: {
            type: Array,
            default: ()=>[]
        },
        glueList: {
            type: Array,
            default: ()=>[]
        },
    },
    methods: {
        initTooth() {
            // 遍历添加对应牙位
            this.forTooth(11, 17);
            this.forTooth(21, 28);
            this.forTooth(31, 37);
            this.forTooth(41, 47);
        },
        forTooth(start, end) {
            for (let i = start; i <= end; i++) {
                this.teeth.push({
                    id: i,
                    active: false
                })
            }
        },
        // 切换选中状态
        toggleSelection(tooth) {
            if(this.isDetail){
                return false;
            }
            // 保存到记录
            this.saveHistory();
            if(this.isShiftPressed && this.shiftStartTooth !== ''){
              this.shiftEndTooth = tooth.id;
            }
            if(this.isShiftPressed&&this.shiftStartTooth&&this.shiftEndTooth){
              this.selectTeeth(tooth);
            }else{
              // if(this.isShiftPressed){
                this.shiftStartTooth = tooth.id;
              // }
              this.selectTooth(tooth);
            }
            this.removeValList(this.selectedTeeth);
            this.removeValList(this.steelTeethList);
            this.removeValList(this.glueTeethList);
            this.$emit('changeTooth', this.selectedTeeth,this.steelTeethList,this.glueTeethList);
        },
        // 单选牙位
        selectTooth(tooth){
          switch (this.adjunct) {
            // 添加无附件
            case '00':
                this.toothToggle(tooth,this.selectedTeeth);
                this.removeListItem(tooth.id,this.steelTeethList);
                this.removeListItem(tooth.id,this.glueTeethList);
                break;
                // 添加钢牙
            case '01':
                this.toothToggle(tooth,this.steelTeethList);
                this.removeListItem(tooth.id,this.glueTeethList);
                this.removeListItem(tooth.id,this.selectedTeeth);
                break;
                // 添加充胶牙
            case '02':
                this.toothToggle(tooth,this.glueTeethList);
                    this.removeListItem(tooth.id,this.steelTeethList);
                    this.removeListItem(tooth.id,this.selectedTeeth);
                break;
          }

        },
        selectTeeth(tooth){
          let start = '';
          let end = '';
          let fir = this.shiftStartTooth;
          let sec = this.shiftEndTooth;
          var up = [17,16,15,14,13,12,11,21,22,23,24,25,26,27];
          var down = [47,46,45,44,43,42,41,31,32,33,34,35,36,37];
          let array = [];
          // 需判断不可跨牙弓选择
          if(up.includes(fir)&&up.includes(sec)){
            start = up.indexOf(fir);
            end = up.indexOf(sec);
            array = up;
          }else if(down.includes(fir)&&down.includes(sec)){
            start = down.indexOf(fir);
            end = down.indexOf(sec);
            array = down;
          }else{
            this.$yxz.msg('不可跨牙弓选择');
            return false;
          }
          if(start>end){
            start -=1;
            [start, end] = [end, start];
          }else{
            start +=1;
          }
          this.teeth.forEach(item => {
            array.forEach((num,v) => {
              if(num===item.id&&v>=start&&v<=end){
                this.selectTooth(item);
              }
            });
          });
          this.shiftStartTooth = '';
          this.shiftEndTooth = '';
        },
        // 添加默认牙位
        toothToggle(tooth,list){
            const index = list.indexOf(tooth.id);
            if (index > -1) {
                list.splice(index, 1);
            } else {
                list.push(tooth.id);
            }
            // 添加移除，然后调用方法查list是否包含，包含return true，否则return false
            this.isTooth(tooth);
        },
        //判断是否是选中牙位
        isTooth(tooth) {
            const selIndex = this.selectedTeeth.indexOf(tooth.id);
            const steelIndex = this.steelTeethList.indexOf(tooth.id);
            const glueIndex = this.glueTeethList.indexOf(tooth.id);
            if(selIndex > -1||steelIndex > -1||glueIndex > -1){
                tooth.active = true;
            }else{
                tooth.active = false;
            }
        },
        // 移除其他list牙位
        removeListItem(toothId,list) {
            const index = list.indexOf(toothId);
            if (index > -1) {
                list.splice(index, 1);
            }
        },
        // 列表去重
        removeValList(list) {
            list = list.filter(item => item !== '' && item !== null && item !== undefined) // 过滤掉空字符串、null 和 undefined
            .filter((item, index, self) => self.indexOf(item) === index); // 过滤掉重复项
        },
        // 遍历teeth全部牙位表的状态
        toothStatus(list) {
            // this.selectedTeeth
            for(let i = 0; i < list.length; i++){
                for(let j = 0; j < this.teeth.length; j++){
                    if(list[i] === this.teeth[j].id){
                        this.teeth[j].active = true;
                        // console.log('list[i]:',list[i],'teeth[j]',this.teeth[j].id);
                    }
                }
            }
        },
        // shift处理shiftStartTooth/shiftEndTooth
        shiftHandle(tooth){
          if(this.isShiftPressed && this.shiftStartTooth !== ''){
            this.shiftEndTooth = tooth.id;
          }
        },
        // 重置所有牙位
        resetAllTeeth() {
            // 清空所有选中列表
            this.selectedTeeth = [];
            this.steelTeethList = [];
            this.glueTeethList = [];
            this.history = [];

            // 重置所有牙齿的 active 状态
            this.teeth.forEach(tooth => {
                tooth.active = false;
            });

            // 重置 shift 相关状态
            this.shiftStartTooth = '';
            this.shiftEndTooth = '';
            this.isShiftPressed = false;

            // 触发事件通知父组件
            this.$emit('changeTooth', this.selectedTeeth, this.steelTeethList, this.glueTeethList);
        },
        saveHistory() {
            const state = {
                selectedTeeth:[...this.selectedTeeth],
                steelTeethList:[...this.steelTeethList],
                glueTeethList:[...this.glueTeethList],
                teeth:this.teeth.map(tooth=>({...tooth}))
            };
            this.history.push(state);

            if(this.history.length>20){
              this.history.shift();
            }
            this.saveSession('toothHistory',this.history);
        },
        // 恢复到上一个状态
        undo() {
            if (this.history.length === 0) {
                this.$message.warning('没有可撤销的操作');
                return;
            }

            const prevState = this.history.pop();

            // 恢复状态
            this.selectedTeeth = [...prevState.selectedTeeth];
            this.steelTeethList = [...prevState.steelTeethList];
            this.glueTeethList = [...prevState.glueTeethList];

            // 恢复牙齿的active状态
            this.teeth.forEach(tooth => {
                const prevTooth = prevState.teeth.find(t => t.id === tooth.id);
                if (prevTooth) {
                    tooth.active = prevTooth.active;
                }
            });

            // 触发事件通知父组件
            this.$emit('changeTooth', this.selectedTeeth, this.steelTeethList, this.glueTeethList);
        },
        saveSession(key,val) {
          sessionStorage.setItem(key, JSON.stringify(val));
        },
    },
    created() {
        // 赋值牙位字段 更新teeth active状态
        this.selectedTeeth = this.teethList;
        this.steelTeethList = this.steelList;
        this.glueTeethList = this.glueList;
        this.initTooth();
        this.toothStatus(this.selectedTeeth);
        this.toothStatus(this.steelTeethList);
        this.toothStatus(this.glueTeethList);
    },
    mounted() {
      window.addEventListener('keydown', (e) => {
        if (e.key === 'Shift') {
          this.isShiftPressed = true;
        }
      });
      window.addEventListener('keyup', (e) => {
        if (e.key === 'Shift') {
          this.isShiftPressed = false;
          this.shiftStartTooth = '';
          this.shiftEndTooth = '';
        }
      });
      this.history = JSON.parse(sessionStorage.getItem('toothHistory')) || [];
    },
    beforeDestroy(){
      sessionStorage.removeItem('toothHistory');
    }
}
</script>
<style lang="scss" scoped>
.tooth-wrap-rpd {
    width: 100%;
    height: 100%;
    position: relative;
}

.tooth-wrap-label-rpd{
    width: 100px;
    height:60px;
    position: absolute;
    line-height: 30px;
    top:46%;
    left: 46%;
}

.tooth-model {
    width: 100%;
    // height: 45%;
    display: flex;
    flex-direction: row;
}

.tooth-model-item {
    width: 50%;
    height: 250px;
    position: relative;

    div img {
        position: absolute;
        width: 100%;
        height: 100%;
        user-select: none;
    }

    div span {
        position: absolute;
        cursor: default;
        user-select: none;
    }
}

.tooth-label {
    width: 20px;
    height: auto;
}

// 上颌左侧
#tooth-11 {
    top: 0%;
    right: 0%;
    width: 15%;
    height: 17%;
}

#tooth-12 {
    top: 4%;
    right: 14%;
    width: 14%;
    height: 17%;
}

#tooth-13 {
    top: 13%;
    right: 23%;
    width: 14%;
    height: 16%;
}

#tooth-14 {
    top: 26%;
    right: 28%;
    width: 16%;
    height: 16%;
}

#tooth-15 {
    top: 40%;
    right: 32%;
    width: 16%;
    height: 16%;
}

#tooth-16 {
    top: 54%;
    right: 35%;
    width: 18%;
    height: 19%;

}

#tooth-17 {
    top: 72%;
    right: 38%;
    width: 18%;
    height: 20%;

}

// 上颌右侧
#tooth-21 {
    top: 0%;
    left: 0%;
    width: 16%;
    height: 16%;
}

#tooth-22 {
    top: 4%;
    left: 14.5%;
    width: 14%;
    height: 16%;

}

#tooth-23 {
    top: 13%;
    left: 23%;
    width: 15.5%;
    height: 16.5%;

}

#tooth-24 {
    top: 28%;
    left: 28.5%;
    width: 17%;
    height: 16%;

}

#tooth-25 {
    top: 41%;
    left: 34%;
    width: 17%;
    height: 16%;

}

#tooth-26 {
    top: 54%;
    left: 38%;
    width: 20%;
    height: 22%;

}

#tooth-27 {
    top: 75%;
    left: 43%;
    width: 19%;
    height: 18%;

}

// 下颌左侧
#tooth-41 {
    bottom: 2%;
    right: 0%;
    width: 11.5%;
    height: 16%;
}

#tooth-42 {
    bottom: 5%;
    right: 10%;
    width: 12.5%;
    height: 16%;
}

#tooth-43 {
    bottom: 11%;
    right: 19%;
    width: 14%;
    height: 16%;
}

#tooth-44 {
    bottom: 23%;
    right: 27%;
    width: 15%;
    height: 15%;
}

#tooth-45 {
    bottom: 36%;
    right: 32.5%;
    width: 13%;
    height: 15%;
}

#tooth-46 {
    bottom: 50%;
    right: 36%;
    width: 19%;
    height: 22%;
}

#tooth-47 {
    bottom: 71%;
    right: 44%;
    width: 18%;
    height: 20%;
}

// 下颌右侧
#tooth-31 {
    bottom: 3%;
    left: 0%;
    width: 11%;
    height: 15%;
}

#tooth-32 {
    bottom: 5%;
    left: 11%;
    width: 13%;
    height: 16%;
}

#tooth-33 {
    bottom: 11%;
    left: 20.5%;
    width: 14%;
    height: 16%;
}

#tooth-34 {
    bottom: 23%;
    left: 27%;
    width: 15%;
    height: 16%;
}

#tooth-35 {
    bottom: 37%;
    left: 31%;
    width: 15%;
    height: 16%;
}

#tooth-36 {
    bottom: 51%;
    left: 35%;
    width: 18%;
    height: 23%;
}

#tooth-37 {
    bottom: 73%;
    left: 41%;
    width: 16%;
    height: 21%;
}

// 牙齿标签id
.tooth-11 {
    top: -10%;
    right: 6%;
}

.tooth-12 {
    top: -5%;
    right: 22%;
}

.tooth-13 {
    top: 9%;
    right: 38%;
}

.tooth-14 {
    top: 25%;
    right: 47%;
}

.tooth-15 {
    top: 40%;
    right: 52%;
}

.tooth-16 {
    top: 58%;
    right: 57%;
}

.tooth-17 {
    top: 77%;
    right: 60%;
}

.tooth-21 {
    top: -10%;
    left: 6%;
}

.tooth-22 {
    top: -5%;
    left: 22%;
}

.tooth-23 {
    top: 9%;
    left: 38%;
}

.tooth-24 {
    top: 25%;
    left: 48%;
}

.tooth-25 {
    top: 40%;
    left: 54%;
}

.tooth-26 {
    top: 58%;
    left: 60%;
}

.tooth-27 {
    top: 77%;
    left: 65%;
}

.tooth-41 {
    bottom: -6%;
    right: 4%;
}

.tooth-42 {
    bottom: -3%;
    right: 18%;
}

.tooth-43 {
    bottom: 5%;
    right: 32%;
}

.tooth-44 {
    bottom: 18%;
    right: 44%;
}

.tooth-45 {
    bottom: 36%;
    right: 50%;
}

.tooth-46 {
    bottom: 53%;
    right: 57%;
}

.tooth-47 {
    bottom: 74%;
    right: 65%;
}

.tooth-31 {
    bottom: -6%;
    left: 3%;
}

.tooth-32 {
    bottom: -2%;
    left: 18%;
}

.tooth-33 {
    bottom: 5%;
    left: 32%;
}

.tooth-34 {
    bottom: 18%;
    left: 41%;
}

.tooth-35 {
    bottom: 36%;
    left: 49%;
}

.tooth-36 {
    bottom: 53%;
    left: 55%;
}

.tooth-37 {
    bottom: 74%;
    left: 60%;
}
</style>



// WEBPACK FOOTER //
// DTooth.vue?2f71e8a1